import {getAxiosInstance} from "../../../np-rest/rest";
import {snackActions} from "../../../sc-utilities/SnackBar";

export const fetchWorkDiagnoseReportCount = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("/report/count", filterData);
            if (countRes.data && countRes.data.succeeded && countRes?.data?.result?.data ) {
                return countRes.data.result.data;
            }
            if (!countRes.data || !countRes.data.succeeded) {
                snackActions.snackBar({
                    message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch diagnose reports."}`,
                    options: {
                        variant: 'warning'
                    }
                });
            }
            return 0;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch diagnose reports."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchWorkDiagnoseReportList = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post("/report/list", filterData);
            if (res.data && res.data.succeeded && res?.data?.result?.data) {
                return res.data.result.data || [];
            }
            if (!res.data || !res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : "Cannot fetch diagnose reports."}`,
                    options: {
                        variant: 'warning'
                    }
                });
            }
            return [];
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch diagnose reports."}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
}


export const regenerateReport = (data) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let result = await rest.post("/report/re-generate", data);
            if (result.data && result.data.succeeded) {
                return { data: result };
            }
            snackActions.snackBar({
                message: `${result.data ? result.data.message : result.message}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: null };
        }
        catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: null };
        }
    }
}
